/* eslint-disable react/jsx-no-constructed-context-values */

/*  Shared  */
import { TABLENAMES } from 'application/Shared/Constants';
import { Route } from 'application/Shared/Helpers';
import { TFunction } from 'i18next';

/*  React  */
import React, { ReactNode, createContext, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavigateFunction, useNavigate, useParams } from 'react-router';

/*
 * A context provider that contains all entities, loading state and tooltip data fetched
 */

export type RecentlyAddedAppsTableContextValue = {
    fromPage: string;
    navigate: NavigateFunction;
    route: string;
    setFromPage: (fromPage: string) => void;
    t: TFunction<'translation', undefined>;
    tableName: string;
};

const defaultFn = () => {};

const DefaultContext: RecentlyAddedAppsTableContextValue = {
    fromPage: '',
    navigate: defaultFn,
    route: '',
    setFromPage: defaultFn,
    t: ((label: string) => label) as unknown as TFunction<
        'translation',
        undefined
    >,
    tableName: TABLENAMES.RECENTLY_ADDED_APPS
};

export const RecentlyAddedAppsTableContext =
    createContext<RecentlyAddedAppsTableContextValue>(DefaultContext);

export const RecentlyAddedAppsTableContextProvider = ({
    children
}: {
    children: ReactNode;
}) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { clientId, partnerId } = useParams();
    const [fromPage, setFromPage] = useState<string>('');

    const route = Route.buildBaseAdminRoute({ clientId: clientId!, partnerId });

    const providerValues: RecentlyAddedAppsTableContextValue = {
        fromPage,
        navigate,
        route,
        setFromPage,
        t,
        tableName: DefaultContext.tableName
    };
    return (
        <RecentlyAddedAppsTableContext.Provider value={providerValues}>
            {children}
        </RecentlyAddedAppsTableContext.Provider>
    );
};

export const useRecentlyAddedAppsTableContext =
    (): RecentlyAddedAppsTableContextValue => {
        const context = useContext<RecentlyAddedAppsTableContextValue>(
            RecentlyAddedAppsTableContext
        );

        if (context === undefined) {
            throw new Error(
                '`useRecentlyAddedAppsTableContext` must be used within `RecentlyAddedAppsTableContextProvider`'
            );
        }

        return context;
    };
